import { COLOUR_FACET_GROUP } from "../../../../constants/nonActionConstants";

export const getHasMoreColours = ({ facetGroupings = [] }) =>
  !!facetGroupings?.some(
    (facetGroup) => facetGroup.type === COLOUR_FACET_GROUP,
  );
